const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  name: state => state.user.name,
  agentId: state => state.user.agentId,
  topAgentName: state => state.user.topAgentName,
  modules: state => state.user.modules,
  visitedViews: state => state.tagsView.visitedViews,
  addRouters: state => state.permission.addRouters,
  permission_routers: state => state.permission.routers,
}
export default getters
